export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;

export const MAPS_API_BASE_URL =
  process.env.REACT_APP_MAPS_API_BASE_URL;

export const PROMOTIONS_API_URL =
  process.env.REACT_APP_PROMOTIONS_API_URL;

export const PROMOTIONS_API_KEY =
  process.env.REACT_APP_PROMOTIONS_API_KEY;

export const MENU_API_URL =
  process.env.REACT_APP_MENU_API_URL;

export const MENU_API_KEY =
  process.env.REACT_APP_MENU_API_KEY;